import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';
import { TimezoneProvider } from './components/utils/TimezoneContext';
import App from './App';
import axios from 'axios';
import ErrorBoundary from './components/utils/ErrorBoundary';
import { installTranslationSafeDom } from './components/utils/translationSafeDom';

installTranslationSafeDom();

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const serverMsg = error && error.response && error.response.data && error.response.data.message;
    if (serverMsg) {
      error.message = serverMsg;
    }
    return Promise.reject(error);
  }
);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ErrorBoundary label="root">
        <Provider store={store}>
            <TimezoneProvider>
                <App />
            </TimezoneProvider>
        </Provider>
    </ErrorBoundary>
);